import { baseApi } from "./baseApi";
import * as API from "@utils/apiPath";
import type {
  ApiResponse,
  GeoFenceDetailApiResponse,
  GeoFenceValues,
} from "interface/geoFence";
import { StatusInterface } from "interface/common";

export const geoFenceApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getGeoFences: builder.query<
      ApiResponse,
      { [key: string]: string | number }
    >({
      query: (params) => ({
        url: API.GET_GEO_FENCE,
        method: "GET",
        params,
      }),
      providesTags: ["GeoFence"],
    }),
    getGeoFenceById: builder.query<GeoFenceDetailApiResponse, string>({
      query: (id) => ({
        url: `${API.GET_GEO_FENCE}/${id}`,
        method: "GET",
      }),
      providesTags: (_result, _err, id) => [{ type: "GeoFence", id }],
    }),
    createGeoFence: builder.mutation<ApiResponse, GeoFenceValues>({
      query: (params) => ({
        url: `${API.GET_GEO_FENCE}/create`,
        method: "POST",
        body: params,
      }),
      invalidatesTags: ["GeoFence"],
    }),
    updateGeoFence: builder.mutation<ApiResponse, GeoFenceValues>({
      query: (params) => ({
        url: API.GET_GEO_FENCE,
        method: "PUT",
        body: params,
      }),
      invalidatesTags: ["GeoFence"],
    }),
    updateGeoFenceStatus: builder.mutation<ApiResponse, StatusInterface>({
      query: ({ id, ...body }) => ({
        url: `/${API.GET_GEO_FENCE}/status/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["GeoFence"],
    }),
    deleteGeoFence: builder.mutation<ApiResponse, string>({
      query: (id) => ({
        url: `/${API.GET_GEO_FENCE}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["GeoFence"],
    }),
    bulkUpdateGeoFenceStatus: builder.mutation<
      ApiResponse,
      { ids: string[]; status: boolean }
    >({
      query: ({ ids, status }) => ({
        url: `/${API.GET_GEO_FENCE}/bulk-status`,
        method: "PUT",
        body: { ids, status },
      }),
      invalidatesTags: ["GeoFence"],
    }),
    bulkDeleteGeoFences: builder.mutation<ApiResponse, { ids: string[] }>({
      query: ({ ids }) => ({
        url: `/${API.GET_GEO_FENCE}/bulk-delete`,
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["GeoFence"],
    }),
  }),
});

export const {
  useGetGeoFencesQuery,
  useGetGeoFenceByIdQuery,
  useCreateGeoFenceMutation,
  useUpdateGeoFenceMutation,
  useUpdateGeoFenceStatusMutation,
  useDeleteGeoFenceMutation,
  useBulkUpdateGeoFenceStatusMutation,
  useBulkDeleteGeoFencesMutation,
} = geoFenceApi;
